/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProcessStep } from './process-step';
import { AffectedService } from './affected-service';
import { OrganisationMetadata } from './organisation-metadata';

export interface TransactionStatusOfOrganisationMetadata {
  readonly affectedServices?: Array<AffectedService> | null;
  transactionId?: string;
  entityId?: string;
  startedAt?: string;
  lastSuccessAt?: string | null;
  updatedAt?: string;
  finishedAt?: string;
  state?: TransactionStatusOfOrganisationMetadataStateEnum;
  progressCount?: number;
  totalCount?: number;
  metadata?: OrganisationMetadata;
  processTitle?: string | null;
  processType?: string | null;
  parentTransactionId?: string;
  processSteps?: Array<ProcessStep> | null;
  startedById?: string | null;
  startedByEmulatorId?: string | null;
  readonly processStepsCount?: number;
  readonly id?: string;
  exception?: any | null;
}
export enum TransactionStatusOfOrganisationMetadataStateEnum {
  Started = 'Started',
  Running = 'Running',
  Finished = 'Finished',
  Published = 'Published',
  Failed = 'Failed',
  Cancelled = 'Cancelled',
  Pending = 'Pending'
}
